import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import { CarouselNavButtons, CarouselProgressBar } from "@repo/ui/carousel";
export function PaginationRow() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="unconstrained-grid mt-8 items-center gap-4 desktop:mt-16 desktop:gap-6"><CarouselNavButtons breakpoint="desktop" variant="grey" className="col-span-1 tablet:col-span-4" /><CarouselProgressBar className="col-span-3 h-1 bg-surface-base-secondary tablet:col-span-8 desktop:h-2" indicatorClassName="inset-y-0 bg-surface-base-disabled" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}